import { render } from "./document_card.vue?vue&type=template&id=74873570"
import script from "./document_card.vue?vue&type=script&lang=js"
export * from "./document_card.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__